<template>
    <modal ref="modal" title="Join us and stay connected" :footerShow="false" @close="onCloseModal">
        <div id="mc_embed_signup" :class="{ active: isActive }">
            <div class="mc_embed_cookie_consent">
                <div>
                    <p>{{ $options.filters['lang']('copy.marketing_consent_message') }}</p>
                    <button class="regular-button" @click="showCookiesSettingsPopup">{{ $options.filters['lang']('copy.marketing_consent_button') }}</button>
                </div>
            </div>
            <form action="https://techsoupeurope.us11.list-manage.com/subscribe/post?u=196f395c5c6f41cdc8696c91f&amp;id=0fdb022de7" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
                    <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
                    <div class="mc-field-group">
                        <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
                        </label>
                        <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
                    </div>
                    <div class="mc-field-group">
                        <label for="mce-FNAME">First Name </label>
                        <input type="text" value="" name="FNAME" class="" id="mce-FNAME">
                    </div>
                    <div class="mc-field-group">
                        <label for="mce-LNAME">Last Name </label>
                        <input type="text" value="" name="LNAME" class="" id="mce-LNAME">
                    </div>
                    <div id="mergeRow-gdpr" class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
                        <div class="content__gdpr">
                            <p class="text-lg mb-2">The Newsletter is available only in English now.</p>

                            <label>Marketing Permissions</label>
                            <p>Please select all the ways you would like to hear from us:</p>
                            <fieldset class="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
                                <label class="checkbox subfield" for="gdpr_44206"><input type="checkbox" id="gdpr_44206" name="gdpr[44206]" value="Y" class="av-checkbox "><span>Email</span> </label><label class="checkbox subfield" for="gdpr_44210"><input type="checkbox" id="gdpr_44210" name="gdpr[44210]" value="Y" class="av-checkbox "><span>Direct Mail</span> </label><label class="checkbox subfield" for="gdpr_44214"><input type="checkbox" id="gdpr_44214" name="gdpr[44214]" value="Y" class="av-checkbox "><span>Customized Online Advertising</span> </label>
                            </fieldset>
                            <p class="mt-3">You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit our website.</p>
                        </div>
                        <div class="content__gdprLegal">
                            <p class="mt-3">We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be transferred to Mailchimp for processing. <a href="https://mailchimp.com/legal/terms" target="_blank">Learn more about Mailchimp's privacy practices here.</a></p>
                        </div>
                    </div>
                    <div id="mce-responses" class="clear">
                        <div class="response" id="mce-error-response" style="display:none"></div>
                        <div class="response" id="mce-success-response" style="display:none"></div>
                    </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_196f395c5c6f41cdc8696c91f_0fdb022de7" tabindex="-1" value=""></div>
                    <div class="clear">
                        <input type="submit" value="Subscribe" name="subscribe" :disabled="!isActive" id="mc-embedded-subscribe" class="regular-button">
                    </div>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import Modal from './Modal'
    export default {
        name: "NewsletterModal",
        components: {Modal},
        data() {
            return {
                mounted: false,
                isActive: false,
            };
        },
        methods: {
            showModal() {
                this.$refs['modal'].show();
            },
            setCookiesState(allowed) {
                this.isActive = allowed;
            },
            addExternalCss() {
                const id = 'newsletter-css';
                if (!document.getElementById(id)) {
                    const link = document.createElement('link');
                    link.id = id;
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = '//cdn-images.mailchimp.com/embedcode/classic-10_7.css';
                    document.head.appendChild(link);
                }
                else {
                    //Not needed, if the css was already loaded then, data was already sent.
                }
            },
            showCookiesSettingsPopup() {
                UC_UI.showSecondLayer(UC_settings.setting_layer);
            },
            onCloseModal() {
                if (this.mounted) {
                    if (location.hash === '#newsletter') {
                        location.hash = '';
                    }
                }
            }
        },
        mounted() {
            this.mounted = true;
            this.addExternalCss();
            if (location.hash === '#newsletter') {
                this.showModal();
            }
        }
    }
</script>

<style scoped>

</style>
